import { get } from "./api";

const WIDGET_URL_REQUEST = "WIDGET_URL_REQUEST";
const WIDGET_URL_SUCCESS = "WIDGET_URL_SUCCESS";

const requestWidgetUrl = () => {
	return (dispatch, getState) => {
		dispatch({ type: WIDGET_URL_REQUEST });

		return get("user/widgeturl", getState()).then((response) => {
			if (response.status >= 400) {
				return { success: false, status: response.status };
			}

			dispatch({
				type: WIDGET_URL_SUCCESS,
				url: response.data.url,
				groupName: response.data.groupName,
			});

			return { success: true, status: response.status };
		});
	};
};

export { WIDGET_URL_REQUEST, WIDGET_URL_SUCCESS, requestWidgetUrl };
